import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { api } from '@/api';

const ViewerAuthContext = createContext(null);

export const useViewerAuth = () => useContext(ViewerAuthContext);

export const ViewerAuthProvider = ({ children }) => {
  const [viewer, setViewer] = useState(null); // null = checking, false = not auth'd
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      // Check localStorage token first
      const token = localStorage.getItem('viewer_token');
      if (!token) {
        setViewer(false);
        setLoading(false);
        return;
      }
      try {
        const res = await api.viewerMe();
        setViewer(res.data);
      } catch {
        localStorage.removeItem('viewer_token');
        setViewer(false);
      } finally {
        setLoading(false);
      }
    };
    check();
  }, []);

  const login = useCallback(async (email, password) => {
    const res = await api.viewerLogin({ email, password });
    if (res.data.token) localStorage.setItem('viewer_token', res.data.token);
    setViewer(res.data);
    return res.data;
  }, []);

  const register = useCallback(async (email, password, name) => {
    const res = await api.viewerRegister({ email, password, name });
    if (res.data.token) localStorage.setItem('viewer_token', res.data.token);
    setViewer(res.data);
    return res.data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.viewerLogout(); } catch { /* ignore */ }
    localStorage.removeItem('viewer_token');
    setViewer(false);
  }, []);

  const setViewerDirect = useCallback((data) => {
    setViewer(data);
  }, []);

  return (
    <ViewerAuthContext.Provider value={{ viewer, loading, login, register, logout, setViewerDirect }}>
      {children}
    </ViewerAuthContext.Provider>
  );
};
